var PD = PD || {};
PD.homepage = PD.homepage || {};

PD.homepage = (function(homepage) {

  homepage.meta = {};

  homepage.meta = {
    lang: homepage.meta.lang || ((typeof DEFAULT_LOCALE !== 'undefined')? DEFAULT_LOCALE : "en_GB") || "en_GB"
  };

  homepage.__h = function(context, key){
    if (!key) {
      key = context;
      context = "";
    }

    var l = i18n.lang;
    i18n.lang = this.meta.lang;
    var outp =  _("main", context, key);
    i18n.lang = l;

    return outp;
  };

  return homepage;

})(PD.homepage || {});